import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';

const sendOrderSupportRequestMutation = gql`mutation send_support_requests($support_request: support_requests_insert_input!){
  insert_support_requests_one(object: $support_request){
    id
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class SendOrderSupportRequestService {
/* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }
/* ----------------------- Send Order Support Request ----------------------- */
  sendOrderSupportRequest(support_request:any){
    return this.apollo.use('external').mutate({
      mutation: sendOrderSupportRequestMutation,
      variables:{
        support_request
      }
    }).toPromise();
  }
}
